// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

.products {
  font-family: "Montserrat", sans-serif;
  color: #333;
  padding: 0;
  margin: 0 auto;
  padding: 0px 0px;
  text-align: center;
  border: 0 !important;
}

.products-heading {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 50px;
  color: #2b2b2b;
  position: relative;
}

/* Product Section */
.product-section {
  display: flex;
  flex-direction: column; 
  align-items: center;
  gap: 20px;
  margin-bottom: 60px;
  padding: 20px;
  text-align: left;
}

.reverse {
  flex-direction: column; 
}

/* Video Container */
.video-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 90%;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}


.video-container::before {
  content: "";
  display: block;
  padding-top: 56.25%; 
}

/* Product Content */
.product-content {
  width: 100%;
  max-width: 600px;
}

.product-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgb(47, 45, 45);
  margin-bottom: 15px;
}

.product-text {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  width: 100%;
}


@media (min-width: 768px) {
  .product-section {
    flex-direction: row; 
    justify-content: space-between;
    align-items: center;
  }

  .reverse {
    flex-direction: row-reverse; 
  }

  .video-container {
    flex: 1 1;
    max-width: 50%; 
  }

  .product-content {
    flex: 1 1;
    max-width: 50%; 
  }
}

/* Footer */
.footer {
  padding: 50px 20px;
  background-color: #333;
  color: white;
  font-family: "Montserrat", sans-serif;
}

.footer-content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: "Montserrat", sans-serif;
}

.footer-section {
  flex: 1 1;
  min-width: 250px;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-family: "Montserrat", sans-serif;
}

.footer-section p {
  font-size: 1rem;
  color: #ccc;
  font-family: "Montserrat", sans-serif;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #ff6b6b;
}

.social-links {
  display: flex;
  gap: 10px;
}

.social-links a {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 1.5rem;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: #ff6b6b;
}

.newsletter-form {
  display: flex;
  gap: 10px;
}

.newsletter-form input {
  padding: 10px;
  border: none;
  border-radius: 5px;
  flex: 1 1;
}

.newsletter-form button {
  padding: 10px 20px;
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.newsletter-form button:hover {
  background-color: #ff4c4c;
}

.footer-bottom {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #555;
}

.footer-bottom p {
  font-size: 0.9rem;
  color: #ccc;
}`, "",{"version":3,"sources":["webpack://./src/components/Products.css"],"names":[],"mappings":";;AAIA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yCAAyC;AAC3C;;;AAGA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAO;IACP,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,cAAc;EAChB;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["\n\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.products {\n  font-family: \"Montserrat\", sans-serif;\n  color: #333;\n  padding: 0;\n  margin: 0 auto;\n  padding: 0px 0px;\n  text-align: center;\n  border: 0 !important;\n}\n\n.products-heading {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 50px;\n  color: #2b2b2b;\n  position: relative;\n}\n\n/* Product Section */\n.product-section {\n  display: flex;\n  flex-direction: column; \n  align-items: center;\n  gap: 20px;\n  margin-bottom: 60px;\n  padding: 20px;\n  text-align: left;\n}\n\n.reverse {\n  flex-direction: column; \n}\n\n/* Video Container */\n.video-container {\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 90%;\n  height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n\n.video-container::before {\n  content: \"\";\n  display: block;\n  padding-top: 56.25%; \n}\n\n/* Product Content */\n.product-content {\n  width: 100%;\n  max-width: 600px;\n}\n\n.product-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: rgb(47, 45, 45);\n  margin-bottom: 15px;\n}\n\n.product-text {\n  font-size: 1.1rem;\n  color: #555;\n  line-height: 1.6;\n  width: 100%;\n}\n\n\n@media (min-width: 768px) {\n  .product-section {\n    flex-direction: row; \n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .reverse {\n    flex-direction: row-reverse; \n  }\n\n  .video-container {\n    flex: 1;\n    max-width: 50%; \n  }\n\n  .product-content {\n    flex: 1;\n    max-width: 50%; \n  }\n}\n\n/* Footer */\n.footer {\n  padding: 50px 20px;\n  background-color: #333;\n  color: white;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.footer-section {\n  flex: 1;\n  min-width: 250px;\n}\n\n.footer-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.footer-section p {\n  font-size: 1rem;\n  color: #ccc;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 10px;\n}\n\n.footer-section ul li a {\n  color: #ccc;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-section ul li a:hover {\n  color: #ff6b6b;\n}\n\n.social-links {\n  display: flex;\n  gap: 10px;\n}\n\n.social-links a {\n  color: white;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1.5rem;\n  transition: color 0.3s ease;\n}\n\n.social-links a:hover {\n  color: #ff6b6b;\n}\n\n.newsletter-form {\n  display: flex;\n  gap: 10px;\n}\n\n.newsletter-form input {\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  flex: 1;\n}\n\n.newsletter-form button {\n  padding: 10px 20px;\n  background-color: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.newsletter-form button:hover {\n  background-color: #ff4c4c;\n}\n\n.footer-bottom {\n  text-align: center;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #555;\n}\n\n.footer-bottom p {\n  font-size: 0.9rem;\n  color: #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
